/* eslint-disable react/prop-types */
import React from "react"
import gql from "graphql-tag"
import { graphql } from "@apollo/client/react/hoc"
import { Redirect } from "react-router"
import { compose, branch, renderComponent } from "recompose"
import { formatRoute } from "react-router-named-routes"
import routes from "../../routes"
import LandingPage from "."

const FacilityRedirect = (props) => (
  <Redirect
    to={formatRoute(routes.overview, { facilityId: props.facilities[0].id })}
  />
)

const LandingPageWithData = compose(
  graphql(
    gql`
      query DefaultRoute {
        user {
          id
          network {
            facilities {
              id
              name
              departments {
                id
                name
              }
              units {
                id
                name
              }
            }
          }
        }
      }
    `,
    {
      props: ({ data: { error, loading, user } }) => {
        if (error) {
          throw error
        }
        if (loading) {
          return { loading }
        }
        return {
          facilities: user.network.facilities.map((facility) => ({
            id: facility.id,
            name: facility.name,
            departments: facility.departments.length,
            units: facility.units.length,
          })),
        }
      },
    }
  ),
  branch(
    ({ facilities }) => facilities && facilities.length === 1,
    renderComponent(FacilityRedirect)
  )
)(LandingPage)

export default LandingPageWithData
